"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAIN_SECTION_PADDING_Y = exports.MAIN_SECTION_PADDING_X = exports.MAIN_SECTION_MAX_WIDTH = void 0;
var MAIN_SECTION_MAX_WIDTH = 1280;
exports.MAIN_SECTION_MAX_WIDTH = MAIN_SECTION_MAX_WIDTH;
var MAIN_SECTION_PADDING_X = 48;
exports.MAIN_SECTION_PADDING_X = MAIN_SECTION_PADDING_X;
var MAIN_SECTION_PADDING_Y = 40;
exports.MAIN_SECTION_PADDING_Y = MAIN_SECTION_PADDING_Y;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/layout/index.js
// module id = 1161
// module chunks = 212